import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
import detail from './detail.js'
import ibooking from './ibooking'


export default new Vuex.Store({
    modules: {
        detail,
        ibooking
    }
})
